import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MailIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function CTASection() {
  const benefits = ['SEO-optimised from the start', 'Mobile-friendly responsive design', 'Fast loading speeds', 'Secure hosting included', '30-day support & training', 'Easy content management'];
  return <section id="contact-section" className="py-3 md:py-4 bg-[#212C34]" data-id="element-256">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="max-w-4xl mx-auto text-center" data-id="element-258">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-259">
            See your new homepage before you spend a penny
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-260">
            <a href="/contact" className="inline-flex items-center justify-center bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-[#0C1B26] px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 mb-4" data-id="element-261">
              Claim your free homepage design
            </a>
            <p className="text-white/80 font-medium" data-id="element-262">
              No deposit. No obligation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}